import React from 'react';
import { createPortal } from 'react-dom';
import Button from '../form/Button/Button';
import './PopUpCompany.scss';

const PopUpCompany = ({ active, company, companyImage, closeCompany }) => {
  if (!active) return null;

  return createPortal(
    <div className="PopUpCompany">
      <div className="puc-backdrop" onClick={closeCompany} />
      <div className="puc-modal">
        {companyImage && (
          <img className="puc-logo" src={companyImage} alt={company} />
        )}
        <p className="puc-title">Está tudo pronto!</p>
        <p className="puc-description">
          <strong>{company}</strong> foi adicionada à lista de empresas nas quais você administra.
        </p>
        <Button onClick={closeCompany}>
          CONTINUAR <span className="fa6-solid--arrow-right" />
        </Button>
      </div>
    </div>,
    document.body
  );
};

export default PopUpCompany;
